/**
 * @generated SignedSource<<1de77c1d25e0d0b59abf07a844f99b4e>>
 * @relayHash a469de3e55f8bb3408fce1e1e71fabf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID baff8a01614629d53f57ac273090a58d1f3cd74280f1a58931b14334f7b84b7a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedTabsAggRootQuery$variables = {
  containerId: string;
  shouldFetchSavedView: boolean;
  viewId: string;
};
export type SavedTabsAggRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedTabsAggData">;
};
export type SavedTabsAggRootQuery = {
  response: SavedTabsAggRootQuery$data;
  variables: SavedTabsAggRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchSavedView"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = {
  "alias": "uuid",
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SavedTabsAggRootQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchSavedView",
            "variableName": "shouldFetchSavedView"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SavedTabsAggData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SavedTabsAggRootQuery",
    "selections": [
      {
        "alias": "goalsDirectoryViews",
        "args": [
          (v3/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 200
          },
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              "FAVOURITED_DATE_DESC"
            ]
          }
        ],
        "concreteType": "TownsquareDirectoryViewConnection",
        "kind": "LinkedField",
        "name": "goals_directoryViewSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareDirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareDirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchSavedView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goalsView",
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "directoryId",
                "variableName": "viewId"
              }
            ],
            "concreteType": "TownsquareDirectoryView",
            "kind": "LinkedField",
            "name": "goals_directoryViewById",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "baff8a01614629d53f57ac273090a58d1f3cd74280f1a58931b14334f7b84b7a",
    "metadata": {},
    "name": "SavedTabsAggRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c05d16a852fe6e01387c21f7807ee2f5";

export default node;
